import React from 'react';

import { Modal, Text, Title, Button, Group, Divider, Stack } from '@mantine/core';
import useArchivePackage from 'hooks/package/useArchivePackage';
import notificationHandler from 'utils/notifications';

interface IArchivePackageModalProps {
  packageId: string;
  open: boolean;
  handleClose: () => void;
}

const ArchivePackageModal = ({ packageId, open, handleClose }: IArchivePackageModalProps): JSX.Element => {
  const archivePackageMutation = useArchivePackage();
  const { successNotification, errorNotification } = notificationHandler();

  const handleArchive = (): void => {
    archivePackageMutation.mutate(packageId, {
      onSuccess: () => {
        handleClose();
        successNotification('Package archived', 'The package has been successfully archived.');
      },
      onError: error => {
        handleClose();
        errorNotification('Archive failed', error.response?.data.message);
      },
    });
  };

  return (
    <Modal
      title={<Title order={4}>Archive Package</Title>}
      size='md'
      padding='md'
      onClose={handleClose}
      opened={open}
      centered
    >
      <Stack>
        <Text align='left'>
          Are you sure you want to archive this package? Archived packages cannot be reactivated but can be
          cloned.
        </Text>
        <Divider />
        <Group position='right'>
          <Button onClick={handleArchive} loading={archivePackageMutation.isLoading}>
            Archive
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ArchivePackageModal;
